import './Input.scss';
import * as React from 'react';
import { omit } from 'lodash';
import classnames from 'classnames';

export type Props = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  invalid: boolean;
  focusOnRender: boolean;
  fullWidth: boolean;
  onLight?: boolean;
};

export default class Input extends React.Component<Props> {
  static defaultProps = {
    type: 'text',
    invalid: false,
    focusOnRender: false,
    fullWidth: false,
  };
  node: HTMLInputElement | undefined | null;
  focus() {
    if (this.node != null) {
      this.node.focus();
    }
  }
  componentDidMount() {
    if (this.props.focusOnRender) {
      this.focus();
    }
  }
  render() {
    const { className, invalid, fullWidth, onLight, ...remainingProps } =
      this.props;
    return (
      <input
        ref={(node) => (this.node = node)}
        className={classnames('Input', className, {
          'Input--invalid': invalid,
          'Input--fullWidth': fullWidth,
          'Input--onLight': onLight,
        })}
        {...omit(remainingProps, 'focusOnRender')}
      />
    );
  }
}
